module.exports = __webpack_public_path__ + "img/fruit_kiwi.9b84dd4d.png";